/**
 * Id of the ChatOBI Q&A API as registered with the Evo BFF proxy. The proxy
 * exchanges the MFE's button token for an API-scoped access token server-side,
 * so no bearer token is handled in the browser.
 */
export const CHATOBI_BACKEND_ID = 'access.hospitality.staah.chatbot.admin';

/**
 * Custom scope of the same API, added to the OIDC token locally and in
 * EvoBuilder so the API sees the scope the BFF proxy supplies in Evo.
 */
export const CHATOBI_API_SCOPE = 'access.hospitality.chatbot.api';
